// Shared constants for the 2026 homepage.

// Primary conversion destinations (reused from existing Banner CTA).
export const BOOKING_URL = 'https://calendar.app.google/URR5NVNKa7FChwa76';
export const DISCOVERY_URL = 'https://calendar.app.google/URR5NVNKa7FChwa76';
export const EMAIL_TOOL_URL = 'https://email-tool.easyappforz.com/';
export const MARKETPLACE_URL =
  'https://www.zendesk.com.mx/marketplace/apps/support/1124202/admin-suite/?queryID=b9eeb32e375e85c88f6e9ad5a2afcb1c';

// Section anchor ids (used by nav + CTA scroll targets).
export const SECTION_IDS = {
  hero: 'hero',
  technologies: 'technologies',
  services: 'services',
  marketplace: 'marketplace',
  results: 'results',
  process: 'process',
  stories: 'stories',
  contact: 'contact',
};

// Technology ecosystem grouped by category.
// `i18n` key under home.ecosystem.groups.<id>.title supplies the heading.
// `logo` paths point to /public/logos/*.svg
export const TECH_GROUPS = [
  {
    id: 'cx',
    items: [
      { name: 'Zendesk', logo: '/logos/zendesk.svg' },
      { name: 'Intercom', logo: '/logos/intercom.svg' },
      { name: 'Chatwoot', logo: '/logos/chatwoot.svg' },
      { name: 'Salesforce', logo: '/logos/salesforce-svgrepo-com.svg' },
      { name: 'Twenty CRM', logo: '/logos/twenty.svg' },
      { name: 'WhatsApp Business', logo: '/logos/whatsapp.svg' },
    ],
  },
  {
    id: 'ai',
    items: [
      { name: 'OpenAI', logo: '/logos/openai-svgrepo-com.svg' },
      { name: 'n8n', logo: '/logos/n8n.svg' },
      { name: 'Typebot', logo: '/logos/typebot.svg' },
      { name: 'OpenCode', logo: '/logos/opencode.svg' },
      { name: 'API Integrations', logo: '/logos/api-svgrepo-com.svg' },
    ],
  },
  {
    id: 'analytics',
    items: [
      { name: 'Google Analytics', logo: '/logos/googleanalytics.svg' },
      { name: 'Plausible', logo: '/logos/plausibleanalytics.svg' },
      { name: 'Looker', logo: '/logos/looker.svg' },
      { name: 'Zendesk Explore', logo: '/logos/zendesk.svg' },
    ],
  },
  {
    id: 'design',
    items: [
      { name: 'Figma', logo: '/logos/figma.svg' },
      { name: 'Jira', logo: '/logos/jira.svg' },
      { name: 'GitHub', logo: '/logos/github.svg' },
      { name: 'Bizagi', logo: '/logos/bizagi.svg' },
    ],
  },
  {
    id: 'infra',
    items: [
      { name: 'AWS', logo: '/logos/aws-svgrepo-com.svg' },
      { name: 'Docker', logo: '/logos/docker.svg' },
      { name: 'PostgreSQL', logo: '/logos/postgresql.svg' },
      { name: 'MongoDB', logo: '/logos/mongodb.svg' },
      { name: 'Railway', logo: '/logos/railway.svg' },
    ],
  },
  {
    id: 'marketing',
    items: [
      { name: 'Meta', logo: '/logos/meta.svg' },
      { name: 'Facebook Campaigns', logo: '/logos/facebook.svg' },
      { name: 'WhatsApp Outbound Messages', logo: '/logos/whatsapp.svg' },
    ],
  },
];

// Service cards. `i18n` supplies title + description via home.services.cards[index].
export const SERVICE_CARDS = [
  { id: 'implementations', icon: 'LayoutGrid' },
  { id: 'ai', icon: 'Sparkles' },
  { id: 'development', icon: 'Code2' },
  { id: 'analytics', icon: 'BarChart3' },
  { id: 'integrations', icon: 'Workflow' },
  { id: 'architecture', icon: 'Network' },
];

// Process steps. `i18n` supplies label + description via home.process.steps[index].
export const PROCESS_STEPS = ['discover', 'design', 'build', 'integrate', 'optimize', 'scale'];

// KPI result cards. `i18n` supplies the label via home.results.items[index].
export const RESULT_KPIS = [
  { value: '250+' },
  { value: '30+' },
  { value: '15+' },
  { value: '6+' },
  { value: '10+' },
  { value: '95%' },
];
